globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

import { createApp } from 'vue'
import FormApp from './FormApp.vue'
import EventsApp from './EventsApp.vue'
import Vueform from '@vueform/vueform'
import vueformConfig from './vueform.config'
import SelfieCropper from './customElements/SelfieCropper.vue'

/**
 * Registered globally because SelfieElement.vue is a vueform *template override*, and
 * vueform renders only its `<template>` — a local `components` option there is not
 * honoured, so the tag would not resolve.
 */
function registerSharedComponents(app) {
    app.component('selfie-cropper', SelfieCropper)
}

window.initNewForm = function(elementId, settings) {
    window.loadedFormScript = true;

    // Check if element exists and isn't already mounted
    const element = document.querySelector(elementId);
    if (!element) {
        console.error(`Element ${elementId} not found`);
        return;
    }

    // Check if already mounted
    if (element.__vue_app__) {
        console.warn(`Vue app already mounted on ${elementId}`);
        return;
    }

    const app = createApp(FormApp, settings)
    vueformConfig.componentName = settings.componentName
    app.use(Vueform, vueformConfig)
    registerSharedComponents(app)
    if (typeof window.initSentry !== "undefined") {
        window.initSentry(app);
    }
    app.mount(elementId)
}

window.initScheduleModule = function(elementId, settings) {
    window.loadedEventsScript = true;

    // Check if element exists and isn't already mounted
    const element = document.querySelector(elementId);
    if (!element) {
        console.error(`Element ${elementId} not found`);
        return;
    }

    // Check if already mounted
    if (element.__vue_app__) {
        console.warn(`Vue app already mounted on ${elementId}`);
        return;
    }

    const app = createApp(EventsApp, settings);
    app.use(Vueform, vueformConfig)
    registerSharedComponents(app)
    if (typeof window.initSentry !== "undefined") {
        window.initSentry(app);
    }
    app.mount(elementId);
}
